export * as Api from './api';

export enum AmlMatchType {
  // Name matching types
  NameExact = 'name_exact',
  AkaExact = 'aka_exact',
  NameFuzzy = 'name_fuzzy',
  AkaFuzzy = 'aka_fuzzy',
  PhoneticName = 'phonetic_name',
  PhoneticAka = 'phonetic_aka',
  EquivalentName = 'equivalent_name',
  EquivalentAka = 'equivalent_aka',
  Unknown = 'unknown',

  // Additional matching factors
  YearOfBirth = 'year_of_birth',
  RemovedPersonalTitle = 'removed_personal_title',
  RemovedPersonalSuffix = 'removed_personal_suffix',
  RemovedOrganisationPrefix = 'removed_organisation_prefix',
  RemovedOrganisationSuffix = 'removed_organisation_suffix',
  RemovedClericalMark = 'removed_clerical_mark',
}

export interface ComplyAdvantageSearchResponse {
  content: {
    data: {
      filters: {
        country_codes: Array<string>;
        types: Array<string>;
        fuzziness: number;
      };
      match_status: string;
      total_hits: number;
      hits: Array<ComplyAdvantageHit>;
      share_url: string;
      ref: string;
    };
  };
}

export interface ComplyAdvantageHit {
  doc: ComplyAdvantageDoc;
  match_types_details: Array<ComplyAdvantageMatchTypeDetail>;
  match_types: Array<string>;
}

interface ComplyAdvantageDoc {
  id: string;
  name: string;
  last_updated_utc: string;
  fields: Array<{
    name: string;
    source: string;
    value: string;
  }>;
}

interface ComplyAdvantageMatchTypeDetail {
  aml_types: Array<string>;
}
